export default {
  data() {
    return {
      dialog: false,
      languages: [
        {
          text: 'Русский',
          value: 'ru',
        },
        {
          text: 'English',
          value: 'en',
        },
        {
          text: 'Украинский',
          value: 'uk',
        },
        {
          text: 'Казахский',
          value: 'kk',
        },
        {
          text: 'Испанский',
          value: 'es',
        },
      ],
      locale: this.$route.query.locale || 'ru',
      name: '',
      text: '',
      link: '',
      image: '',
      dateStart: new Date(),
      dateEnd: new Date(),
      countriesExcluded: '',
      countriesIncluded: '',
      sitesExcluded: '',
      sitesIncluded: '',
      active: false,
      delImage: false,
      imageFile: null,
    }
  },

  methods: {
    getLocalValue(val) {
      if (val === '') {
        return ''
      }
      const obj = JSON.parse(val)
      return obj[this.locale]
    },
    getMultiTextValue(val, local) {
      if (val === '') {
        return ''
      }
      const obj = JSON.parse(val)
      return obj[local]
    },
    getAllLocalValue(val) {
      if (val === '') {
        return ''
      }
      let res = ''
      for (const language of this.languages) {
        const obj = JSON.parse(val)
        res += obj[language.value] + '<br/>'
      }
      return res
    },
    onImageChanged(event) {
      if (event.target.validity.valid && event.target.files.length > 0) {
        this.imageFile = event.target.files[0]
      }
    },
    onDelImageChanged(val) {
      this.delImage = val
    },
    onNameChanged(val) {
      this.name = val
    },
    onTextChanged(val) {
      this.text = val
    },
    onLinkChanged(val) {
      this.link = val
    },
    onDateStartChanged(val) {
      this.dateStart = val
    },
    onDateEndChanged(val) {
      this.dateEnd = val
    },
    onCountriesExcludedChanged(val) {
      this.countriesExcluded = val
    },
    onCountriesIncludedChanged(val) {
      this.countriesIncluded = val
    },
    onSitesExcludedChanged(val) {
      this.sitesExcluded = val
    },
    onSitesIncludedChanged(val) {
      this.sitesIncluded = val
    },
    onActiveChanged(val) {
      this.active = val
    },
    async onLanguageChanged(val) {
      this.locale = val
      await this.$router.push({
        query: {
          locale: val,
        },
      })
    },
    onUpload(val) {
      this.files = val
    },
  },
  watch: {
    async $route(to, from) {
      if (to.query.locale) {
        this.locale = to.query.locale
        await this.$apollo.queries.banner.refetch()
      }
    },
  },
}
